import { useCallback, useContext, useEffect, useState } from "react";
import { Avatar, Badge, Button, Col, Layout, Menu, Modal, Row, List, Typography } from "antd";

import {
  UserOutlined,
  BellOutlined,
  ExclamationCircleFilled,
  FileOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import UserContext from "../../providers/UserContext";
import NetworkApi from "../../network/networkApi";
import config from "../../config";
import { Link } from "react-router-dom";
import moment from "moment";

const { Header } = Layout;
const { SubMenu } = Menu;

const getAttachments = (item: any) => {
  const attachments = Array.isArray(item.attachments) ? item.attachments : [];
  return attachments.length > 0
    ? attachments
    : item.attachmentName
      ? [{ name: item.attachmentName, originalName: item.attachmentOriginalName || item.attachmentName }]
      : [];
};

const UserMenu = () => {
  const [current, changeCurrent] = useState("key");
  const { user } = useContext(UserContext);
  const [announcements, setAnnouncements] = useState<any[]>([]);
  const [announcementOpen, setAnnouncementOpen] = useState(false);
  useEffect(() => {
    NetworkApi.requestGet("/api/announcement/dashboard").then((response) => {
      if (response.resultCode === 200 && Array.isArray(response.result)) {
        setAnnouncements(response.result);
        if (response.result.length > 0) setAnnouncementOpen(true);
      }
    });
  }, []);
  const handleClick = (e: any) => {
    changeCurrent(e.key);
  };
  const logout = useCallback(async () => {
    await NetworkApi.requestGet("/api/auth/logout");
    window.location.href = "/";
  }, []);
  return (
    <Header>
      <Row justify={"space-between"}>
        <Col span={12}></Col>
        <Col span={12}>
          <Row justify={"end"} gutter={15}>
            <Col>
              <Menu
                onClick={handleClick}
                selectedKeys={[current]}
                mode="horizontal"
                theme={"dark"}
              >
                <Menu.Item key="notification">
                  <span onClick={() => setAnnouncementOpen(true)} style={{ cursor: "pointer" }}>
                    <Badge count={announcements.length} overflowCount={99}>
                      <Avatar icon={<BellOutlined />} />
                    </Badge>
                  </span>
                </Menu.Item>
                <SubMenu
                  key="SubMenu"
                  icon={<UserOutlined />}
                  title={`${user?.lastName} ${user?.firstName}`}
                >
                  <Menu.Item key="profile1">
                    <Link to={"/user/profile"}>Хувийн мэдээлэл</Link>
                  </Menu.Item>
                  <Menu.Item key="profile2">
                    <Link
                      target="_blank"
                      to={{
                        pathname:
                          "https://drive.google.com/drive/u/2/folders/1_zX7qnYbNO5vmG39RsqtwCSA3m895Qr-",
                      }}
                    >
                      <FileOutlined /> Систем ашиглах заавар
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="profile3">
                    <Link
                      target="_blank"
                      to={{
                        pathname: "https://www.youtube.com/watch?v=ZGRx2nB56Lg",
                      }}
                    >
                      <VideoCameraOutlined /> Бүртгүүлэх заавар
                    </Link>
                  </Menu.Item>
                  <Menu.Item onClick={logout} key="logout">
                    Гарах
                  </Menu.Item>
                </SubMenu>
              </Menu>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal title="Мэдэгдэл" open={announcementOpen} onCancel={() => setAnnouncementOpen(false)} footer={<Button type="primary" onClick={() => setAnnouncementOpen(false)}>Ойлголоо</Button>} width={620}>
        <List
          dataSource={announcements}
          locale={{ emptyText: "Идэвхтэй мэдэгдэл байхгүй" }}
          split={false}
          renderItem={(item) => (
            <List.Item style={{ padding: "8px 0" }}>
              <div style={{ width: "100%" }}>
                <div style={{ textAlign: "center", color: "#d48806", marginBottom: 14 }}>
                  <ExclamationCircleFilled style={{ fontSize: 72 }} />
                  <div style={{ fontSize: 32, fontWeight: 700, marginTop: 8 }}>Анхааруулга</div>
                </div>
                <div style={{ background: "#fffbe6", border: "1px solid #ffe58f", borderRadius: 12, padding: 24 }}>
                  <Typography.Text strong style={{ display: "block", fontSize: 20, marginBottom: 12 }}>{item.title}</Typography.Text>
                  <div style={{ whiteSpace: "pre-wrap", fontSize: 16, lineHeight: 1.7 }}>{item.content}</div>
                  {getAttachments(item).length > 0 && <div style={{ marginTop: 14 }}><Typography.Text strong>Хавсралтууд:</Typography.Text>{getAttachments(item).map((file: any) => <div key={file.name}><a href={`${config.get("apiUrl")}/tmp/${file.name}`} target="_blank" rel="noreferrer">{file.originalName || file.name}</a></div>)}</div>}
                  <div style={{ marginTop: 18, color: "#595959" }}>Оруулсан огноо: {item.createdAt ? moment(item.createdAt).format("YYYY-MM-DD HH:mm") : "-"}</div>
                  <div style={{ color: "#595959" }}>Байгууллага: {item.organizationName}</div>
                </div>
              </div>
            </List.Item>
          )}
        />
      </Modal>
    </Header>
  );
};
export default UserMenu;
